import { useEffect, useContext } from 'react';
import { useHistory, Link } from 'react-router-dom';

import ServerError from '../layout/ServerError';
import Spinner from '../layout/Spinner';
import BackToTop from '../layout/BackToTop';
import Utility from '../util/Utility';
import MiniHeroSection from '../containers/MiniHeroSection';

import TrophysContext from '../../context/trophys/trophysContext';

import { REQOP_BY_NUM } from '../../context/types';

const Retired = () => {
  const history = useHistory();
  const trophysContext = useContext(TrophysContext);
  const { loading, retiredTrophys } = trophysContext;

  const onSelectTrophy = (trophyNum) => {
    trophysContext.searchTrophy(REQOP_BY_NUM, trophyNum);
    history.push('/search');
  };

  useEffect(() => {
    !retiredTrophys &&
      (async () => {
        await trophysContext.searchRetired();
      })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mb-5">
      <MiniHeroSection
        titleText="Retired"
        sectionClassExtra="mb-4"
        iconName="fa-face-frown"
      />

      <div className="container">
        <p>
          A list of retired Trophys that are understood to no longer be with us.
        </p>
        <ServerError />
        {loading && <Spinner />}

        {retiredTrophys && (
          <>
            {!retiredTrophys.found ? (
              <div className="card border-warning mt-4">
                <div className="card-body">
                  <h5 className="card-title text-white">
                    {retiredTrophys.info}
                  </h5>
                  <p className="card-text">Please try again later.</p>
                </div>
              </div>
            ) : (
              <>
                {!retiredTrophys.info.retiredTrophys ? (
                  <div className="text-white">
                    No retired Trophys were found!
                  </div>
                ) : (
                  <>
                    <div className="text-white mb-3">
                      {Utility.getPluralisedWithValueIfNeeded(
                        'car',
                        retiredTrophys.info.retiredTrophys.length,
                      )}{' '}
                      found.
                    </div>

                    <div className="row g-3 mb-3">
                      {retiredTrophys.info.retiredTrophys.map(
                        (trophy, index) => (
                          <div key={index} className="col-lg-6">
                            <div className="card bg-body-tertiary shadow">
                              <div className="card-header">
                                <div className="d-flex justify-content-between align-items-end">
                                  <h4 className="tt-heading text-white mb-0">
                                    Trophy #{trophy.number.padStart(3, '0')}
                                  </h4>
                                  <div>
                                    {trophy.originalReg ?? (
                                      <div className="small text-secondary">
                                        Registration unknown
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="card-body">
                                <div className="row g-3">
                                  <div className="col-6 col-xl-4">
                                    <div className="small text-muted">
                                      Registration Date
                                    </div>
                                    <div className="text-white">
                                      {trophy.registrationDate ? (
                                        <>
                                          {new Date(
                                            trophy.registrationDate,
                                          ).toLocaleDateString(undefined, {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                          })}
                                        </>
                                      ) : (
                                        <div className="text-secondary">
                                          Unknown
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  <div className="col-6 col-xl-4 text-end text-xl-start">
                                    <div className="small text-muted">
                                      VIN Number
                                    </div>
                                    <div className="text-white">
                                      {trophy.vehicleIdNum ?? (
                                        <div className="text-secondary">
                                          Unknown
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  <div className="col-sm-12 col-xl-4 text-center">
                                    <button
                                      type="button"
                                      className="btn btn-danger w-100"
                                      onClick={() =>
                                        onSelectTrophy(trophy.number)
                                      }
                                    >
                                      More...
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ),
                      )}
                    </div>

                    <div className="col-12">
                      <div className="card bg-body-tertiary shadow p-3">
                        <h3 className="text-warning mb-3">
                          Wrong Information?
                        </h3>
                        <div>
                          If you believe this information to be in error then
                          please don't hesitate to reach out and inform us. You
                          can reach us via our{' '}
                          <Link to="/contact">Contact</Link> page.
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </>
        )}

        <BackToTop />
      </div>
    </div>
  );
};

export default Retired;
